import { Navigate, generatePath } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { useHotelPolicyEditQuery } from "./model/repository";
import { HotelPolicyEditDefaultPresenter } from "./presenter";

type Props = {
	hotelID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const HotelPolicyEditDefaultContainer = ({ hotelID, activeLangCode, navigator }: Props) => {
	const { data: serverModel } = useHotelPolicyEditQuery({ hotelID });

	if (!serverModel?.hotelPolicy) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<HotelPolicyEditDefaultPresenter
			hotelID={hotelID}
			activeLangCode={activeLangCode}
			navigator={navigator}
			serverModel={serverModel}
		/>
	);
};

HotelPolicyEditDefaultContainer.displayName = "HotelPolicyEditDefaultContainer";
